import React, { useState } from "react"
import { CSSTransition } from "react-transition-group"
import { useLifecycles } from "react-use"
import { useForm } from "react-hook-form"
import { validationRules } from "../checkout2/constants"
import { Input, InputFile } from "../checkout2/ui/input"
import { vacanciesCvApi } from "../api/vacancies"
import Modal from "../Modal"

export default function ModalVacanciesForm() {
  const [isSelfOpen, setIsSelfOpen] = useState(true)
  const [isSuccessOpen, setIsSuccessOpen] = useState(false)
  const [isSendingForm, setIsSendingForm] = useState(false)

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors, defaultValues, isValid },
  } = useForm({
    mode: "onTouched",
    reValidateMode: "onTouched",
    shouldFocusError: true,
    defaultValues: {
      name: "",
      phone: "",
      city: "",
      cv_file: "",
    },
  })

  const handleModalClose = (e) => {
    e.stopPropagation()
    if (!e.target.closest(".modal-content") || e.target.classList.contains("js-close")) {
      setIsSelfOpen(false)
    }
  }

  const onSubmit = (data) => {
    const payload = {
      name: data.name,
      phone: data.phone.replace(/\D/g, ""),
      city: data.city,
      cv_file: "",
      cv_file_ext: "",
    }

    const file = data.cv_file[0]
    if (file) {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onloadend = async () => {
        payload.cv_file = reader.result
        payload.cv_file_ext = file.name.split(".").pop()

        try {
          setIsSendingForm(true)
          vacanciesCvApi(payload)
            .then(() => {
              setIsSuccessOpen(true)
              setIsSelfOpen(false)
            })
            .catch((error) => {
              console.log("Error: ", error)
            })
            .finally(() => {
              setIsSendingForm(false)
            })
        } catch (error) {
          console.log("Error: ", error)
        }
      }
      reader.onerror = (error) => {
        console.log("Error reading file: ", error)
      }
    } else {
      console.log("No file selected")
    }
  }

  useLifecycles(() => {
    document.documentElement.classList.add("overflow")
  })

  return (
    <>
      <CSSTransition
        in={isSelfOpen}
        appear
        unmountOnExit
        classNames="fade"
        timeout={300}
        onExit={() => {
          document.documentElement.classList.remove("overflow")
        }}
      >
        <>
          <div
            className="modal modal--mobile-bottom-sheet modal--vacancies-form"
            data-target="modal-vacancies-form"
            style={{ display: "block" }}
            onClick={handleModalClose}
          >
            <div className="modal__zoom">
              <div className="modal-content modal-contect--narrow">
                <div className="close-btn js-close" onClick={handleModalClose} />
                <div className="modal__content">
                  <div className="modal__title">
                    {window.labels.vacancies.forms.cvModalTitle}
                  </div>
                  <div className="modal__subtitle">
                    {window.labels.vacancies.forms.modalSubtitle}
                  </div>
                  <div className="modal__content-body scrolling-block">
                    <form
                      onSubmit={handleSubmit(onSubmit)}
                      id="vacancies_form"
                      className="vacancies-form"
                    >
                      <div className="form-label-list">
                        <Input
                          title={window.labels.vacancies.forms.cv.name}
                          type="text"
                          focus={Boolean(defaultValues.name)}
                          isError={Boolean(errors["name"])}
                          autoComplete="off"
                          {...register("name", {
                            required: true,
                            setValueAs: (value) => value.trim(),
                          })}
                        />
                        <Input
                          title={window.labels.vacancies.forms.cv.phone}
                          type="tel"
                          isError={Boolean(errors["phone"])}
                          autoComplete="off"
                          {...register("phone", {
                            ...validationRules["phone"],
                          })}
                        />
                        <Input
                          title={window.labels.vacancies.forms.cv.city}
                          type="text"
                          isError={Boolean(errors["city"])}
                          autoComplete="off"
                          {...register("city", {
                            required: true,
                          })}
                        />
                        <InputFile
                          title={window.labels.vacancies.forms.cv.cvFile}
                          type="file"
                          isError={Boolean(errors["cv_file"])}
                          watch={watch}
                          buttonTitle={window.labels.vacancies.forms.cv.cvFileButton}
                          {...register("cv_file", {
                            required: true,
                          })}
                          note={window.labels.vacancies.forms.cv.cvFileHint}
                        />
                      </div>
                    </form>
                    <span className="vacancies-form-agree">
                      {window.labels.vacancies.forms.agreeText}
                    </span>
                  </div>

                  {/* <Footer /> */}
                  <div className="row_btn">
                    <button
                      type="submit"
                      className={`wb-btn btn-green vacancies-form-submit ${
                        isSendingForm || !isValid ? "disabled" : ""
                      }`}
                      form="vacancies_form"
                      disabled={isSendingForm || !isValid}
                    >
                      {window.labels.vacancies.forms.sendButton}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Calendar */}
          <div className="date-calendar">
            <div className="calendar-holder">
              <div id="dateCalendar" />
              <div className="date-calendar__content">
                <div className="wb-btn btn-yellow save-calendar close-calendar">
                  <span>{window.labels.personal.general.apply}</span>
                </div>
                <div className="close-calendar">
                  {window.labels.personal.general.cancel}
                </div>
              </div>
            </div>
          </div>
          {/* /Calendar */}
        </>
      </CSSTransition>
      <CSSTransition
        in={isSuccessOpen}
        appear
        unmountOnExit
        classNames="fade"
        timeout={300}
      >
        <Modal
          title={window.labels.vacancies.forms.successModalTitle}
          modalView="xs"
          cssModifyer="-mobile-bottom-sheet modal--vacancies-success"
          onRequestClose={() => setIsSuccessOpen(false)}
        >
          <div className="form-content">
            <p className="body-r-16">
              <span>{window.labels.vacancies.forms.successModalText}</span>
            </p>
            <a
              href={window.labels.vacancies.forms.homeLinkUrl || "/"}
              className="successful-home-link"
            >
              {window.labels.vacancies.forms.homeLinkText || "Home"}
            </a>
          </div>
        </Modal>
      </CSSTransition>
    </>
  )
}
